import { render, staticRenderFns } from "./FormatoPoligrafoComponent.vue?vue&type=template&id=3eaf1b0f&scoped=true&"
import script from "./FormatoPoligrafoComponent.vue?vue&type=script&lang=js&"
export * from "./FormatoPoligrafoComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormatoPoligrafoComponent.vue?vue&type=style&index=0&id=3eaf1b0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaf1b0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSimpleTable,VSpacer})
